import { FC } from 'react';
import { i18n as I18n } from '../../../utils/i18n';

import { weekdays } from '../../../constants/weekdays';

import useIsMobile from '../../../hooks/useIsMobile';
import { OpeningTimes } from '../../../hooks/useVenue';

interface Props {
  openingTimes: OpeningTimes;
}

const NonClinicalTimes: FC<Props> = ({ openingTimes }) => {
  const isMobileView = useIsMobile();

  const startTime = day => {
    return openingTimes[`${day}Start`];
  };

  const endTime = day => {
    return openingTimes[`${day}End`];
  };

  const openTimes = day => {
    if (
      startTime(day) &&
      endTime(day) &&
      parseInt(endTime(day), 10) - parseInt(startTime(day), 10) !== 0
    ) {
      return `${startTime(day)} - ${endTime(day)}`;
    }
    return I18n.t('shared.closed');
  };

  const weekDay = day => {
    return isMobileView ? day.charAt(0) : day;
  };

  return (
    <tbody>
      {weekdays.map(day => {
        return (
          <tr key={day}>
            <td className="booking-times__day">{weekDay(day)}</td>
            <td className="booking-times__hours">{openTimes(day)}</td>
          </tr>
        );
      })}
    </tbody>
  );
};

export default NonClinicalTimes;
